<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 12.1038C12.6354 12.1038 12.6146 12.1038 12.5833 12.1038C12.5313 12.0934 12.4583 12.0934 12.3958 12.1038C9.375 12.0101 7.09375 9.63509 7.09375 6.70801C7.09375 3.72884 9.52083 1.30176 12.5 1.30176C15.4792 1.30176 17.9063 3.72884 17.9063 6.70801C17.8958 9.63509 15.6042 12.0101 12.6979 12.1038C12.6875 12.1038 12.6771 12.1038 12.6667 12.1038ZM12.5 2.86426C10.3854 2.86426 8.65625 4.59342 8.65625 6.70801C8.65625 8.79134 10.2812 10.4684 12.3542 10.5413C12.4062 10.5309 12.5521 10.5309 12.6875 10.5413C14.7292 10.4476 16.3333 8.77051 16.3438 6.70801C16.3438 4.59342 14.6146 2.86426 12.5 2.86426Z"
      :fill="color"
    />
    <path
      d="M12.6764 23.4899C10.6348 23.4899 8.58268 22.9691 7.0306 21.9274C5.58268 20.9691 4.79102 19.6566 4.79102 18.2295C4.79102 16.8024 5.58268 15.4795 7.0306 14.5107C10.1556 12.4378 15.2181 12.4378 18.3223 14.5107C19.7598 15.4691 20.5618 16.7816 20.5618 18.2087C20.5618 19.6357 19.7702 20.9587 18.3223 21.9274C16.7598 22.9691 14.7181 23.4899 12.6764 23.4899ZM7.89518 15.8232C6.89518 16.4899 6.35352 17.3441 6.35352 18.2399C6.35352 19.1253 6.9056 19.9795 7.89518 20.6357C10.4889 22.3753 14.8639 22.3753 17.4577 20.6357C18.4577 19.9691 18.9993 19.1149 18.9993 18.2191C18.9993 17.3337 18.4473 16.4795 17.4577 15.8232C14.8639 14.0941 10.4889 14.0941 7.89518 15.8232Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      default: "#292626",
      type: String,
    },
  },
};
</script>
